export const DATE_FORMAT = 'DD MMM YYYY';
export const TIME_INPUT_FORMAT = 'HH:mm:ss';
export const TIME_OUTPUT_FORMAT = 'HH:mm';
